import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useCommand} from 'hooks';
import {useEntityContext} from 'components/EntityPage/EntityContext';
import {AssignedRequirementWithID} from '../../AssignedEntities/AssignedRequirementColumns';
import {Regulation} from 'types';
import {useParams} from 'react-router-dom';
import {ProjectDetailsPageParams} from '../../vehicleProjectPagePaths';
import {ProjectRelevanceDialog} from './ProjectRelevanceDialog';

export const ProjectRelevanceButton: React.FC = () => {
	const {t} = useTranslation('features/vehicleprojects', {
		keyPrefix: 'ProjectRelevantFields',
	});
	const {selectedItems} = useEntityContext<
		AssignedRequirementWithID | Regulation
	>();
	const {modelSeries, generation} = useParams() as ProjectDetailsPageParams;
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handleProjectRelevanceClick = React.useCallback(() => {
		setIsDialogOpen(true);
	}, []);

	const handleDialogClose = React.useCallback(() => {
		setIsDialogOpen(false);
	}, []);

	// Detect if we're working with regulations or requirements
	const isRegulation =
		selectedItems.length > 0 && 'regulationNumber' in selectedItems[0];

	useCommand(
		{
			key: 'projectRelevance',
			text: t('ProjectRelevanceBtn'),
			iconProps: {iconName: 'TaskLogo'},
			priority: 6,
			disabled: selectedItems.length === 0,
			onClick: handleProjectRelevanceClick,
		},
		[selectedItems, handleProjectRelevanceClick, t],
	);

	const singleSelectedItem =
		selectedItems.length === 1 ? selectedItems[0] : null;

	// For requirements, we can show existing values
	const initialIsProjectRelevant =
		!isRegulation && singleSelectedItem
			? (singleSelectedItem as AssignedRequirementWithID).isProjectRelevant
			: true;
	const initialComments =
		!isRegulation && singleSelectedItem
			? (singleSelectedItem as AssignedRequirementWithID)
					.projectRelevantComments
			: '';

	return (
		<ProjectRelevanceDialog
			isOpen={isDialogOpen}
			onClose={handleDialogClose}
			modelSeries={modelSeries}
			generation={generation}
			requirementIds={isRegulation ? [] : selectedItems.map(item => item.id)}
			regulationIds={isRegulation ? selectedItems.map(item => item.id) : []}
			initialIsProjectRelevant={initialIsProjectRelevant}
			initialComments={initialComments}
		/>
	);
};
